import { useModal } from '@/hooks'
import { Box, Stack } from '@mui/material'
import { TetronLoadingIcon } from './icons'
import { ModalType } from '@/store/app'

export const ChangeOrganization = () => {
  const { modalOpened } = useModal()

  return modalOpened === ModalType.ORGANIZATION_CHANGE ? (
    <Box
      sx={{
        visibility:
          modalOpened === ModalType.ORGANIZATION_CHANGE ? 'visible' : 'hidden',
        transition: 'all 0.5s ease-out',
        position: 'absolute',
        zIndex: 999999,
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: '#FFFFFF',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Stack
        gap={'16px'}
        sx={{
          color: '#222222',
          fontWeight: '500',
          fontSize: '36px',
          justifyContent: 'center',
          alignItems: 'center',
        }}
      >
        <TetronLoadingIcon />
        Смена организации
      </Stack>
    </Box>
  ) : null
}
